import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import Button from '../../../atoms/buttons/Button';
import {
  IconAddCircle,
} from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import Drawer from '../../../molecules/modals/Drawer';

import * as BEM from 'react-bem-helper';
import { mediaTypeDefinitionsMap } from '../LicenseBuilder/config';

import { defaultLicensePresets } from './default-presets';
import './styles.scss';

interface ILicensePresetsMenuProps {
  onClose(): void;
  onSelectPreset(usage: ILicenseUsage): void;
  onOpenLicenseBuilder(): void;
}

interface IMappedProps extends ILicensePresetsMenuProps {
  userProducerLocation: ILicenseComponent;
}

interface ILicensePresetsMenuState {
  isOpen: boolean;
}

const classes = new BEM('license-presets-menu');

interface IPresetsListItemOptions {
  icon: JSX.Element;
  content: JSX.Element;
  onClick: () => void;
  key: string;
  className?: string;
}
function blockMouseEvents(e) {
  e.stopPropagation();
}

export class LicensePresetsMenu extends React.Component<IMappedProps, ILicensePresetsMenuState> {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
  }

  onClose = () => {
    this.setState({ isOpen: false }, () => {
      this.props.onClose();
    });
  }

  renderLicensePresetListItem = (usage: any, index) => {
    const { label, icon } = mediaTypeDefinitionsMap[usage.medium.internal_id];

    const name = usage.medium.value_label;

    const content = (
      <>
        <span {...classes('preset-name')}>{label || name}</span>
        {usage.contextual_param ?
          <span>
            <small className="param">{usage.contextual_param[0].label}: </small>
            <small className="value">{usage.contextual_param[0].value_label}</small><br />
          </span> :
          null}
          <span>
          <small className="param">{usage.term ? usage.term.label : 'Duration'}: </small>
            <small className="value">{usage.term ? usage.term.value_label : 'Perpetuity'}</small>
          </span>
      </>
    );

    return this.renderListItem({
      key: `preset-${index}`,
      icon,
      content,
      onClick: () => this.props.onSelectPreset(usage),
    });
  }

  renderCustomLicenseListItem = () => {
    const label = 'Custom License';
    return this.renderListItem({
      key: 'custom-license-btn',
      icon: <IconAddCircle />,
      content: <span {...classes('preset-name')}>{label}</span>,
      onClick: () => this.props.onOpenLicenseBuilder(),
      className: 'custom-license-list-item',
    });
  }

  renderListItem = ({ key, onClick, icon, content, className }: IPresetsListItemOptions) => {
    return (
      <li
        key={key}
        onClick={onClick}
        className={className}
      >
        <Button variant="icon" icon={icon} size="large"/>
        <Span size="medium" {...classes('preset-description')}>
          {content}
        </Span>
        <Button
          className="select-license-preset-button"
          colorScheme="accent"
          label="Select"
          variant="pill"
          size="small"
        />
      </li>
    );
  }

  render() {
    return (
      <Drawer
        position="left"
        closeButtonLabel="Cancel"
        open={this.state.isOpen}
        onClose={this.onClose}
        {...classes()}
      >
        <div
          {...classes('content')}
        >
          <Heading
            is="h4"
            textColor="black"
            {...classes('title')}
          >
            Select a License
          </Heading>

          <div>
            <Button
              className="sample-license-button"
              hyperLinkProps={{
                href: 'https://assets.boppermusic.com/docs/Bopper_Sample_License.pdf',
                target: '_blank',
              }}
              wrapperComponent="a"
              colorScheme="black-outline"
              variant="pill"
              size="small"
              label="Preview License"
            />
          </div>

          <ul {...classes('presets-list')}>
            {defaultLicensePresets(this.props.userProducerLocation).map(this.renderLicensePresetListItem)}
            {this.renderCustomLicenseListItem()}
          </ul>
        </div>
      </Drawer>
    );
  }
}

class LicensePresetsMenuPortalContent extends React.Component<IMappedProps> {
  render() {
    const { onClose } = this.props;
    return (
      <div
        className="license-presets-menu-portal"
        onClick={function blockClickEvents(e) { e.stopPropagation(); onClose();  }}
        onMouseEnter={blockMouseEvents}
        onMouseLeave={blockMouseEvents}
        onMouseOver={blockMouseEvents}
        onMouseMove={blockMouseEvents}
        onPointerEnter={blockMouseEvents}
        onPointerLeave={blockMouseEvents}
        onPointerOver={blockMouseEvents}
        onPointerMove={blockMouseEvents}
      >
        <LicensePresetsMenu {...this.props} />
      </div>
    );
  }
}

// tslint:disable-next-line:max-classes-per-file class-name
class LicensePresetsMenuPortal_ extends React.Component<IMappedProps> {
  render() {
    return ReactDOM.createPortal(
      <LicensePresetsMenuPortalContent {...this.props} />,
      document.getElementsByClassName('drawer-wrapper')[0],
    );
  }
}

function getUserProducerLocation(licenseComponents: GQL.ILicenseComponents) {
  let producerLocation: ILicenseComponent;

  try {
    const node = licenseComponents.producer_locations!.edges!.find((edge) => edge.node!.is_user_location!)!.node!;
    producerLocation = {
      id: node.internal_id!,
      name: node.name,
    };
  } catch {
    producerLocation = {
      id: 5177,
      name: 'United States of America',
    };
  }

  return producerLocation;
}

export const LicensePresetsMenuPortal = connect<IMappedProps, {}, ILicensePresetsMenuProps, IStoreState>(
  ({ license, staticData: { licenseComponents } }, props) => ({
    userProducerLocation: getUserProducerLocation(licenseComponents as GQL.ILicenseComponents),
    ...props,
  }),
)(LicensePresetsMenuPortal_);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/forms/LicensePresetsMenu/index.tsx